export type RoomCategory = {
  readonly id: number;
  readonly name: string;
};

export function createRoomCategory(values: unknown): RoomCategory {
  const { id, name } = values as RoomCategory;

  return {
    id,
    name,
  };
}
